import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
  import { BUILDER_ESTIMATOR_STEPS_MAP } from "@/constants/builderEstimatorStepNavigationTextMap";
  import { useBuilderEstimatorStepIndicator } from "@/hooks/estimator-tool/useBuilderEstimatortStepIndicator";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderMobileStepPagination',
  props: {
    steps: {},
    currentStep: {},
    houseDesign: {}
  },
  emits: ["select-next", "select-prev"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const { isLastStep, isFirstStep, backStepTextButton, nextStepTextButton } =
    useBuilderEstimatorStepIndicator(props);

  const nextButtonIsDisabled = computed(() => {
    return (
      props.currentStep === BuilderEstimatorSteps.VIEW_DESIGN &&
      !props.houseDesign
    );
  });
  const nextStepTextButtonControlled = computed(() => {
    if (nextButtonIsDisabled.value) {
      return "Select a Home Design to Continue";
    }

    return nextStepTextButton.value;
  });

  const emit = __emit;

  const onSelectNext = () => {
    emit("select-next");
  };

  const onSelectPrev = () => {
    emit("select-prev");
  };

const __returned__ = { props, isLastStep, isFirstStep, backStepTextButton, nextStepTextButton, nextButtonIsDisabled, nextStepTextButtonControlled, emit, onSelectNext, onSelectPrev, computed, get BuilderEstimatorSteps() { return BuilderEstimatorSteps }, get BUILDER_ESTIMATOR_STEPS_MAP() { return BUILDER_ESTIMATOR_STEPS_MAP }, get useBuilderEstimatorStepIndicator() { return useBuilderEstimatorStepIndicator }, get HouseDesignInterface() { return HouseDesignInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})